import angular from 'angular';

import { LogService } from './log.service';

export const logModule = 'sis-components.logService';

(function () {
    angular.module(logModule, []).factory('logService', () => new LogService());
}());
